import { render, staticRenderFns } from "./index.vue?vue&type=template&id=52cff22c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cff22c",
  null
  
)

/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=pagination&%3Asize=pagination.size&%3Apage=pagination.page&%3Atotal=totalCount&%40pageChanged=handlePageChanged"
if (typeof block0 === 'function') block0(component)

export default component.exports